import {
  FileText,
  ShieldAlert,
  BadgeCheck,
  ClipboardList,
  Activity,
  Siren,
  MessageSquareHeart,
  Sparkles,
} from "lucide-react";

export const MODULES = [
  {
    slug: "ecm",
    icon: FileText,
    title: "ECM: Policy & Procedure",
    tagline: "Version control that just works.",
    description:
      "Say goodbye to clunky folders and outdated documents. An AI-supported way to create, manage, and control every policy — all in one place.",
    bullets: [
      "AI-assisted drafting & updates",
      "Built-in comprehension testing",
      "Access on any device, anywhere",
    ],
  },
  {
    slug: "risk",
    icon: ShieldAlert,
    title: "Enterprise Risk Management",
    tagline: "Build a risk-aware culture.",
    description:
      "Identify, track, and manage enterprise and operational risks. Align risk practices with strategic goals and regulatory expectations.",
    bullets: [
      "Crowd-sourced risk identification",
      "Intuitive risk dashboards",
      "Multiple risk registers from one hub",
    ],
  },
  {
    slug: "credentials",
    icon: BadgeCheck,
    title: "Automated Credentials",
    tagline: "Always current, always compliant.",
    description:
      "Keep every clinical and non-clinical credential in one central, intelligent system. Automates compliance — no more spreadsheets or guesswork.",
    bullets: [
      "Automatic AHPRA sync & validation",
      "Continuous monitoring for changes",
      "Smart renewal reminders",
    ],
  },
  {
    slug: "audit",
    icon: ClipboardList,
    title: "Clinical & Non-Clinical Audit",
    tagline: "A new benchmark for audit.",
    description:
      "Effortless data collection from any device or via API — with real-time compliance monitoring and instant notifications when thresholds are exceeded.",
    bullets: [
      "Mobile & web-enabled capture",
      "Audit questions linked to risk controls",
      "Instant threshold notifications",
    ],
  },
  {
    slug: "assurance",
    icon: Activity,
    title: "Real-Time Assurance",
    tagline: "Zero manual effort.",
    description:
      "The world's most integrated frontline assurance platform. Automatically captures assurance data at scale for true population-based monitoring.",
    bullets: [
      "API-driven clinical assurance",
      "Population-based monitoring",
      "Robotic clinical process controls",
    ],
  },
  {
    slug: "incident",
    icon: Siren,
    title: "Incident Management",
    tagline: "Respond faster. Recover smarter.",
    description:
      "A proactive, clinically focused approach to incident management and business continuity — with confidence, clarity, and speed.",
    bullets: [
      "Automatic BCP activation",
      "Purpose-built investigation workflows",
      "Centrally managed incident data",
    ],
  },
  {
    slug: "feedback",
    icon: MessageSquareHeart,
    title: "Feedback & Improvement",
    tagline: "Listen, learn, improve.",
    description:
      "Capture, manage, and act on all patient, consumer, and family feedback. Every insight becomes an opportunity to strengthen care quality.",
    bullets: [
      "Centralised feedback management",
      "PDCA-driven improvement framework",
      "Improvements linked to standards",
    ],
  },
];

export const AI_MODULE = {
  slug: "ai",
  icon: Sparkles,
  title: "Embedded AI",
  tagline: "Smarter governance. Safer care. Less effort.",
  description:
    "AI is woven through every module — helping teams work faster, spot risks earlier, and stay accreditation-ready with minimal effort.",
  bullets: [
    "AI-assisted policies & procedures",
    "Predictive assurance & trend insights",
    "Accreditation-ready evidence packs",
  ],
};
